import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { getEnvironmentAsync } from '@onviobr/services/environment';
import { cookie, deferred } from '@onviobr/services/utils';
import { cloudEventFieldRenameMap } from '../models/field-rename-map';
import { jsonParseWithFieldNameMap } from '../utils';
export var WebSocketService = /*#__PURE__*/function () {
  function WebSocketService(config) {
    _classCallCheck(this, WebSocketService);
    this.config = config;
    this.subjectId = void 0;
    this.routingKey = void 0;
    this.socketsPathInitialized = deferred();
    this.socket = void 0;
    this.connectionAttempts = 0;
    this.reopenWhenClosed = false;
    this.switchingRoute = false;
    void this.fetchEnvironmentSocketsUrl();
  }
  return _createClass(WebSocketService, [{
    key: "subscribe",
    value: function () {
      var _subscribe = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(routingKey, subjectId, callback, errorHandler, eventDeserializationMap) {
        var socketsPath;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!this.socket) {
                _context.next = 4;
                break;
              }
              this.switchRoute(routingKey, subjectId);
              _context.next = 12;
              break;
            case 4:
              _context.next = 6;
              return this.socketsPathInitialized.then(function (path) {
                return path;
              });
            case 6:
              socketsPath = _context.sent;
              this.subjectId = subjectId;
              this.routingKey = routingKey;
              this.reopenWhenClosed = true;
              this.connectionAttempts = 0;
              this.connect(socketsPath, callback, errorHandler, eventDeserializationMap);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function subscribe(_x, _x2, _x3, _x4, _x5) {
        return _subscribe.apply(this, arguments);
      }
      return subscribe;
    }()
  }, {
    key: "send",
    value: function send(message) {
      if (this.socket) {
        this.socket.send(message);
      } else {
        this.log('send: no socket');
      }
    }
  }, {
    key: "close",
    value: function close() {
      if (this.socket) {
        this.reopenWhenClosed = false;
        this.socket.close();
      }
    }
  }, {
    key: "fetchEnvironmentSocketsUrl",
    value: function () {
      var _fetchEnvironmentSocketsUrl = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var env, socketsPath, socketsURL, token;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getEnvironmentAsync();
            case 2:
              env = _context2.sent;
              socketsURL = env.RoutingTable.SocketServices;
              socketsPath = (this.config.ssl ? 'wss' : 'ws') + socketsURL.substring(socketsURL.indexOf(':')) + this.config.connectPath;
              if (location.hostname === 'localhost') {
                token = cookie('UDSLongToken');
                socketsPath += "?token=".concat(token);
              }
              this.socketsPathInitialized.resolve(socketsPath);
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function fetchEnvironmentSocketsUrl() {
        return _fetchEnvironmentSocketsUrl.apply(this, arguments);
      }
      return fetchEnvironmentSocketsUrl;
    }()
  }, {
    key: "switchRoute",
    value: function switchRoute(routingKey, subjectId) {
      this.send("unroute:".concat(this.routingKey, ":").concat(this.subjectId));
      this.subjectId = subjectId;
      this.routingKey = routingKey;
      this.switchingRoute = true;
    }
  }, {
    key: "connect",
    value: function connect(socketsPath, callback, errorHandler, eventDeserializationMap) {
      var _this = this;
      ++this.connectionAttempts;
      this.log("Starting Socket: ".concat(this.connectionAttempts));
      var webSocket = new WebSocket(socketsPath);
      webSocket.onopen = this.listenToRoute.bind(this);
      webSocket.onerror = function (ev) {
        _this.log('Socket Error', ev);
        if (errorHandler) {
          errorHandler(ev);
        }
        if (_this.config.reconnectOnError) {
          _this.close();
          _this.connect(socketsPath, callback, errorHandler, eventDeserializationMap);
        }
      };
      webSocket.onclose = function (ev) {
        _this.log('Socket Closed: ' + ev.reason);
        _this.socket = undefined;
        if (_this.connectionAttempts <= _this.config.reconnectAttempts && _this.reopenWhenClosed) {
          _this.connect(socketsPath, callback, errorHandler);
        }
      };
      webSocket.onmessage = function (ev) {
        if (typeof ev.data === 'string' && ev.data.startsWith('added:')) {
          return;
        }
        if (typeof ev.data === 'string' && ev.data.startsWith('removed:')) {
          if (_this.switchingRoute) {
            _this.listenToRoute();
          } else if (_this.config.unexpectedMessageHandler) {
            _this.config.unexpectedMessageHandler(ev);
          }
        } else {
          try {
            var cloudEvent = _this.deserializeEventJson(ev.data, eventDeserializationMap);
            if (cloudEvent) {
              callback(cloudEvent.data);
            } else throw new Error();
          } catch (_unused) {
            if (_this.config.unexpectedMessageHandler) {
              _this.config.unexpectedMessageHandler(ev);
            }
          }
        }
      };
      this.socket = webSocket;
    }
  }, {
    key: "listenToRoute",
    value: function listenToRoute() {
      var route = "route:".concat(this.routingKey, ":").concat(this.subjectId);
      this.send(route);
      this.log('Subscribe to route', "route:".concat(this.routingKey, ":").concat(this.subjectId));
    }
  }, {
    key: "log",
    value: function log() {
      if (this.config.log) {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        this.config.log(args);
      }
    }
  }, {
    key: "deserializeEventJson",
    value: function deserializeEventJson(json, eventDeserializationMap) {
      var map = cloudEventFieldRenameMap;
      if (eventDeserializationMap) {
        map = Object.assign(map, eventDeserializationMap);
      }
      var result = jsonParseWithFieldNameMap(json, map);
      return result;
    }
  }]);
}();
var provider = {
  WebSocketService: WebSocketService
};
export function mockWebSocketServiceProvider(mock) {
  provider = mock;
}
export function webSocketServiceConstructor() {
  return provider.WebSocketService;
}
